module.exports = __webpack_public_path__ + "static/img/2.e0873da.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting596/images/2.png
// module id = 7tfw
// module chunks = 4